import {
	SET_ACTIVE_VIEW,
	RECEIVE_UPDATE_VIEW,
	RECEIVE_DELETE_VIEW,
	RECEIVE_ADD_VIEW,
	RECEIVE_ALL_VIEW_ELEMENTS,
	RECEIVE_EXTENDED_VIEW_ELEMENTS,
} from '../actions/viewActionsRedux';

import { RECEIVE_LOGOUT_USER } from '../actions/activeUserActions';

const initialActiveViewState = {
	_id: null,
	displayTitle: {
		de: 'Unbenannt',
		en: 'Unnamed',
	},
	description: {
		de: '',
		en: '',
	},
	config: {
		classType: '',
		classGUID: '',
	},
	model: null,
	isActive: false,
	viewType: null,
	layouts: [],
	startLayouts: [],
	rootAttributes: [],
	allElements: [],
	layeredElements: [],
	projectSettings: {},
};

export const activeViewReducer = (state = initialActiveViewState, action) => {
	switch (action.type) {
		case SET_ACTIVE_VIEW:
			const view = action.payload.views.find((view) => view._id === action.payload.viewId);
			return view === undefined ? initialActiveViewState : view;
		case RECEIVE_UPDATE_VIEW:
			//sets state to updated view
			return action.payload;
		case RECEIVE_ADD_VIEW:
			return action.payload;

		case RECEIVE_DELETE_VIEW:
			return state;
		case RECEIVE_LOGOUT_USER:
			//sets new state and fetching ended
			return { ...initialActiveViewState, isFetching: false };
		case RECEIVE_ALL_VIEW_ELEMENTS: {
			// if we receive new view data for the active view we store it in state
			if (action.payload.viewId === state._id) {
				let newAttributes = { ...action.payload };
				delete newAttributes.viewId;
				return { ...state, ...newAttributes };
			}
			return state;
		}
		case RECEIVE_EXTENDED_VIEW_ELEMENTS: {
			// if we receive new view data for the active view we store it in state
			if (action.payload.viewId === state._id) {
				if (!state.extendedViewElementsList) {
					state.extendedViewElementsList = [];
				}
				for (const viewElement of action.payload.extendedViewElementsList) {
					if (!state.extendedViewElementsList.find((el) => el._id === viewElement._id)) {
						state.extendedViewElementsList.push(viewElement);
					}
				}
			}
			return state;
		}
		default:
			return state;
	}
};
